import React, { useState } from "react";

const ProductInfo = ({ selectedProd }) => {
  return (
    <>
      <h4 className="prod-name">{selectedProd.name}</h4>
      <h5>{selectedProd.description}</h5>
      <div className="prod-info-line">
        <p className="prod-brand">{selectedProd.brandName}</p>

        {selectedProd.netContent && (
          <>
            <span className="line">|</span>
            <span className="prod-details">
              {selectedProd.netContent["value"]}
            </span>
            <span>{selectedProd.netContent["uOM"]}</span>
          </>
        )}
        {selectedProd.kosherSupervision?.length && (
          <>
            <span className="line">|</span>
            <span
              className={
                selectedProd.kosherSupervision[0]["classification"] === "בשרי"
                  ? "fleshy"
                  : selectedProd.kosherSupervision[0]["classification"] ===
                      "חלבי"
                    ? "milky"
                    : "parve"
              }
            >
              {selectedProd.kosherSupervision[0]["classification"]}
            </span>
          </>
        )}
      </div>
    </>
  );
};
export default ProductInfo;
